import { render, staticRenderFns } from "./ayuda.vue?vue&type=template&id=5865be4b"
import script from "./ayuda.vue?vue&type=script&setup=true&lang=js"
export * from "./ayuda.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports